import { render, staticRenderFns } from "./ExcluirMetodoAutenticacaoModal.vue?vue&type=template&id=0931faaf&scoped=true&"
import script from "./ExcluirMetodoAutenticacaoModal.vue?vue&type=script&lang=js&"
export * from "./ExcluirMetodoAutenticacaoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0931faaf",
  null
  
)

export default component.exports